import { useState } from "react";

import { BasesConcursoDto, EtapasConcursoDto, HTMLDto, PremiosConcursoDto, VideosDto, IntegrantesDto } from "../models/ConcursoTikTok2025.model";
import {
    getEtapasConcursoData,
    getBasesConcursoData,
    getPremiosConcursoData,
    getIntroduccionConcursoData,
    getTematicasConcursoData,
    getVideosData,
    getIntegrantesData
} from "../api/concursoTikTok2025";

export const useConcursoTikTok = () => {
  const [etapas, setEtapas] = useState<EtapasConcursoDto[]>([]);
  const [bases, setBases] = useState<BasesConcursoDto[]>([]);
  const [premios, setPremios] = useState<PremiosConcursoDto[]>([]);
  const [introduccion, setIntroducccion] = useState<HTMLDto>();
  const [tematicas, setTematicas] = useState<HTMLDto>();  
  const [videos, setVideos] = useState<VideosDto[]>([]);
  const [integrantes, setIntegrantes] = useState<IntegrantesDto[]>([]);
  const [isWinnerTitlesPainted,setIsWinnerTitlesPainted] = useState<boolean>(false)
  const [isSpecialMentionTitlesPainted,setIsSpecialMentionTitlesPainted] = useState<boolean>(false)

  const getEtapas = async (anio:any) => {
    try {
      const data = await getEtapasConcursoData(anio);
      setEtapas(data)
    } catch (err) {
      console.warn(err);
    }
  };

  const getBases = async (anio:any) => {
    try {
      const data = await getBasesConcursoData(anio)
      setBases(data)
    } catch (err) {
      console.warn(err);
    }
  };


  const getPremios = async (anio:any) => {
    try {
      const data = await getPremiosConcursoData(anio)
      setPremios(data)
    } catch (err) {
      console.warn(err);
    }
  };

  const getIntroduccion = async (anio:any) => {
    try {
      const data: [HTMLDto] = await getIntroduccionConcursoData(anio)
      setIntroducccion(data[0])
    } catch (err) {
      console.warn(err);
    }
  };

  const getTematicas = async (anio:any) => {
    try {
      const data: [HTMLDto] = await getTematicasConcursoData(anio)
      setTematicas(data[0])
    } catch (err) {
      console.warn(err);
    }
  };

  const getVideos = async (anio:any) => {
    try {
      const data = await getVideosData(anio);
      setVideos(data)
    } catch (err) {
      console.warn(err);
    }
  };

  const getIntegrantes = async (anio:any) => {
    try {
      const data = await getIntegrantesData(anio);
      setIntegrantes(data)
    } catch (err) {
      console.warn(err);
    }
  };

  return {
    etapas,
    bases,
    premios,
    introduccion,
    tematicas,
    videos,
    integrantes,
    isWinnerTitlesPainted,
    isSpecialMentionTitlesPainted,
    getEtapas,
    getBases,
    getPremios,
    getIntroduccion,
    getTematicas,
    getVideos,
    getIntegrantes,
    setIsWinnerTitlesPainted,
    setIsSpecialMentionTitlesPainted
  };
};


